import { isDev } from '@/utils/environments/environments';

export const getSentryDsn = (): string =>
  import.meta.env.VITE_APP_SENTRY_DSN || '';

export const getSentryEnv = (): string => {
  if (isDev()) {
    return 'local';
  }

  return import.meta.env.VITE_APP_SENTRY_ENVIRONMENT || 'local';
};

export const getSentryTransactionRate = (): number => {
  try {
    const transactionRate = Number.parseFloat(
      import.meta.env.VITE_APP_SENTRY_TRANSACTION || '1.0',
    );
    if (Number.isNaN(transactionRate)) {
      return 1;
    }
    return transactionRate;
  } catch {
    return 1;
  }
};

export const getSentryDistSetting = (): string | undefined => {
  if (isDev()) {
    return undefined;
  }

  return import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist;
};

export const getSentryReleaseVersion = (): string | undefined => {
  if (isDev()) {
    return undefined;
  }

  return import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release;
};
